import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import Slider from 'react-slick';
import _ from 'lodash';
import 'slick-carousel/slick/slick.css';
import TimeSlotCard from '../../components/TimeSlotCard/';
import LeftNavButton from './LeftNavButton';
import RightNavButton from './RightNavButton';

const settings = {
  vertical: true,
  arrows: true,
  prevArrow: <LeftNavButton />,
  nextArrow: <RightNavButton />,
  slidesToShow: 4,
  slidesToScroll: 4,
  speed: 500,
  adaptiveHeight: false,
  infinite: false,
  autoplay: false,
  draggable: false,
  responsive: [
    {
      breakpoint: 768,
      settings: { slidesToShow: 2, slidesToScroll: 2 }
    }
  ]
};

class TimeSlots extends React.PureComponent {

  componentDidMount() {
    // Slider component has problems rendering its content properly on first render.
    // This fixes the issue (although not very elegantly).
    setTimeout(() => {
      this.slider.innerSlider.onWindowResized();
    }, 50);
  }

  componentDidUpdate() {
    this.slider.slickGoTo(0);
  }

  render() {
    const { timeSlots, selectedTimeSlot, onClick, t, units } = this.props;
    console.log('Rendering time slots', timeSlots, units);
    return (
      <div className="time-slots-wrapper">
        <Slider ref={(ref) => { this.slider = ref }} {...settings}>
          {
            timeSlots.map((timeSlot) => {
              const active = _.isEqual(timeSlot, selectedTimeSlot);
              return (
                <div key={`${timeSlot.resource}-${timeSlot.timeMoment.format()}`}>
                  <TimeSlotCard
                    active={active}
                    timeSlot={timeSlot}
                    unit={units[timeSlot.unit]}
                    onClick={onClick}
                    actionElement={<span className="time-slot-action-text">{t('time_slot_call_to_action')}</span>}
                  />
                </div>
              );
            })
          }
        </Slider>
      </div>
    );
  }
}

TimeSlots.propTypes = {
  timeSlots: PropTypes.array.isRequired,
  units: PropTypes.shape({}).isRequired,
  selectedTimeSlot: PropTypes.object,
  onClick: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired
};

TimeSlots.defaultProps = {
  selectedTimeSlot: null
};

export default translate(['booking'], { wait: true })(TimeSlots);



// WEBPACK FOOTER //
// ./src/containers/TimeSlots/TimeSlots.jsx